import { createSlice } from '@reduxjs/toolkit';
import { userApi } from '@/store/api/userApi';

interface UserProfile {
  id: string;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  isSelfRegistered?: boolean;
  isAffiliateUser?: boolean;
  role?: { name: string };
}

interface UserState {
  profile: UserProfile | null;
}

const initialState: UserState = {
  profile: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.profile = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      userApi.endpoints.getUserProfile.matchFulfilled,
      (state, { payload }) => {
        state.profile = payload;
      }
    );
  },
});

export const { clearUser } = userSlice.actions;
export default userSlice.reducer;
